import { PartialDate, partialDateFromString } from './PartialDate';

export interface RangedDateInputValue {
  startDateObject?: PartialDate;
  endDateObject?: PartialDate;
  rangedDateString: string;
}

export const rangedDateInputValueFromString = (value: string) => {
  const [maybeStartDate, maybeEndDate] = value.split(' - ').map(partialDateFromString);

  return {
    startDateObject: maybeStartDate?.dateObject,
    endDateObject: maybeEndDate?.dateObject,
    rangedDateString: value,
  };
};
